import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildingApartmentTwo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.66667 3.99992H6.66667M4.66667 6.66658H6.66667M4.66667 9.33325H6.66667M4.66667 11.9999H6.66667M11.3333 9.33325H12M11.3333 11.9999H12M8.26667 14.6666C8.64004 14.6666 8.82672 14.6666 8.96933 14.5939C9.09477 14.53 9.19676 14.428 9.26067 14.3026C9.33333 14.16 9.33333 13.9733 9.33333 13.5999V6.66658M8.26667 14.6666H12.9333C13.3067 14.6666 13.4934 14.6666 13.636 14.5939C13.7614 14.53 13.8634 14.428 13.9273 14.3026C14 14.16 14 13.9733 14 13.5999V8.79992C14 8.05318 14 7.67981 13.8547 7.3946C13.7268 7.14371 13.5229 6.93974 13.272 6.81191C12.9868 6.66659 12.6134 6.66658 11.8667 6.66658H9.33333M8.26667 14.6666H3.06667C2.6933 14.6666 2.50661 14.6666 2.36401 14.5939C2.23856 14.53 2.13658 14.428 2.07266 14.3026C2 14.16 2 13.9733 2 13.5999V3.46659C2 2.71985 2 2.34648 2.14532 2.06126C2.27316 1.81038 2.47713 1.60641 2.72801 1.47858C3.01323 1.33325 3.3866 1.33325 4.13333 1.33325H7.2C7.94674 1.33325 8.32011 1.33325 8.60532 1.47858C8.8562 1.60641 9.06018 1.81038 9.18801 2.06126C9.33333 2.34648 9.33333 2.71985 9.33333 3.46659V6.66658",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBuildingApartmentTwo);
export default ForwardRef;
